import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import type { Tier } from "../../types";
import getTierLevel from "./getTierLevel";

type Props = {
  tier: Tier;
  locked: boolean;
};

const TierBars: FC<Props> = ({ tier, locked }) => {
  const {
    state: { progress, currentPoints },
  } = useRewardCenter();
  const { milestones, reached } = getTierLevel(tier, currentPoints);

  const segments = (
    <div className="flex w-full gap-1">
      {milestones.map((milestone, index) => (
        <div
          key={milestone.id}
          className="rc-track flex-1 overflow-hidden bg-background/60"
        >
          <div
            className="rc-fill"
            style={{ width: `${segmentFill(index, reached, progress)}%` }}
          />
        </div>
      ))}
    </div>
  );

  if (locked) {
    return <div className="flex h-2.25 items-center">{segments}</div>;
  }

  return (
    <div data-slot="tier-bars" className="relative h-2.25">
      <div className="rc-face rc-face-one">
        <div className="rc-track w-full bg-muted/75">
          <div className="rc-fill rc-knob" style={{ width: `${progress}%` }} />
        </div>
      </div>
      <div className="rc-face rc-face-many">{segments}</div>
    </div>
  );
};

const segmentFill = (index: number, reached: number, progress: number) => {
  if (index < reached) return 100;
  if (index === reached) return progress;
  return 0;
};

export default TierBars;
